/**
 * Sleeping Zen — révélation douce au scroll.
 * Pose .sz-reveal sur les éléments cibles puis .sz-in à l'entrée
 * dans le viewport (IntersectionObserver). Respecte
 * prefers-reduced-motion ; sans JS, rien n'est masqué.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.product-card',
    '.blog-post-item',
    '.collection-card__link',
    '.cart-page__summary',
    '.accordion .details',
  ].join(',');

  var STAGGER_MS = 70;
  var STAGGER_MAX = 5;

  function reveal(root) {
    var targets = root.querySelectorAll(SELECTORS);
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('sz-in');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
    );

    targets.forEach(function (el, index) {
      if (el.classList.contains('sz-reveal')) return;
      // Décalage léger au sein d'une même rangée pour un effet cascade.
      var siblingIndex = 0;
      var node = el.parentElement ? el : null;
      if (node && el.parentElement.children.length > 1) {
        siblingIndex = Array.prototype.indexOf.call(el.parentElement.children, el);
      }
      el.style.setProperty('--sz-delay', (siblingIndex % STAGGER_MAX) * STAGGER_MS + 'ms');
      el.classList.add('sz-reveal');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      reveal(document);
    });
  } else {
    reveal(document);
  }
})();
